module.exports = __webpack_public_path__ + "static/media/18ECA40.3f064ad6.jpg";